import { useKeycloak } from "@react-keycloak/web";
import { Suspense } from "react";
import { AuthProvider } from "../../context/auth.context";
import useKeycloakData from "../../hooks/useKeycloakData";

import Loader from "../../layouts/Loader/Loader";

import { TransactionProvider } from "../../context/_transaction.context";
import { TransactionServerSideProvider } from "../../context/transactionServerSide.context";
import { UserManagmentProvider } from "../../context/user.management.context";
import { VendingProvider } from "../../context/vending.context";
import AdminPanelRoutes from "./AdminPanelRoutes";

import { DevicesProvider } from "../../context/devices.context";
import { ExportProvider } from "../../context/export.context";
import { MapProvider } from "../../context/map.context";
import { OnboardingProvider } from "../../context/onboarding.context";
import { CampaignProvider } from "../../context/campaign.context";
import { DateProvider } from "../../context/date.context";
import { POSProvider } from "../../context/pos.context";

import { VendingFilterProvider } from "../../context/vending.filter.context";
import AdminLayout from "../../layouts/AdminLayout";
import { ReporterProvider } from "../../context/reporting.context";
import { ServerSidePagingProvider } from "../../context/ssp.context";

export default function AdminPanelApp() {
  const { initialized } = useKeycloak();

  const { firstName, lastName } = useKeycloakData();
  const currentUser = { firstName, lastName };

  if (!initialized) {
    return <Loader />;
  }

  return (
    <Suspense fallback={<AdminLayout />}>
      <TransactionServerSideProvider>
        {/* <TransactionProvider> */}
        <MapProvider>
          <VendingProvider>
            <ExportProvider>
              <ReporterProvider>
                <VendingFilterProvider>
                  <OnboardingProvider>
                    <CampaignProvider>
                      <POSProvider>
                        <DevicesProvider>
                          <AuthProvider user={currentUser}>
                            <UserManagmentProvider>
                              <DateProvider>
                                <ServerSidePagingProvider>
                                  <AdminPanelRoutes baseUri={`${process.env.PUBLIC_URL}`} />
                                </ServerSidePagingProvider>
                              </DateProvider>
                            </UserManagmentProvider>
                          </AuthProvider>
                        </DevicesProvider>
                      </POSProvider>
                    </CampaignProvider>
                  </OnboardingProvider>
                </VendingFilterProvider>
              </ReporterProvider>
            </ExportProvider>
          </VendingProvider>
        </MapProvider>
        {/* </TransactionProvider> */}
      </TransactionServerSideProvider>
    </Suspense>
  );
}
